// The law's three states, in the words the user reads: to do · doing · done.
// One module on purpose (the cure, Nov 4 2026) — Paul doesn't love "in
// motion", and the next better word should be a one-line change, not a hunt.
// The stored status values ('todo' / 'doing' / 'done') never change; only
// what the screen says.
export const STATE_WORDS = { todo: 'to do', doing: 'doing', done: 'done' };

// Display word for an action. Keeps the pre-cure edge-case semantics:
// a status of 'done' without the completed flag reads as still doing.
export const stateWord = (action) =>
  action.completed
    ? STATE_WORDS.done
    : (action.status === 'doing' || action.status === 'done')
      ? STATE_WORDS.doing
      : STATE_WORDS.todo;
